'use client';

import { FieldErrors, UseFormRegister } from 'react-hook-form';
import PhoneNumberInput from '@/components/Input/PhoneNumberInput';
import { UnsubscribeFormData } from './Form';
import { fieldRules } from '@/utils/form';

interface Props {
  phoneValue: string;
  register: UseFormRegister<UnsubscribeFormData>;
  errors: FieldErrors<UnsubscribeFormData>;
}

const PhoneNumberUnsubscribe = ({ register, errors, phoneValue }: Props) => {
  return (
    <PhoneNumberInput
      id="phone"
      label="Phone Number"
      placeholder="Your phone number"
      error={errors.phone}
      currentValue={phoneValue}
      register={register('phone', fieldRules.phone)}
    />
  );
};

export default PhoneNumberUnsubscribe;
